import React, { useLayoutEffect, useEffect } from 'react'
import { searchBarFocusState } from '@landscape/ui-lib'
import { PreferencesSection } from '.'
import { selectUserRid } from '@landscape/ui-redux'
import { setPageCode } from 'contextUtil'
import { useSetRecoilState } from 'recoil'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { InstitutionInfo } from 'components/etc/InstitutionInfo'

const ClickableLink = styled.a`
  color: #2903ff;
`

const InfoSection = styled.div`
  text-align: left;

  p {
    margin-bottom: 20px;
  }
`

const Home: React.FC = () => {
  const rid = useSelector(selectUserRid)
  const setSearchBarFocus = useSetRecoilState(searchBarFocusState)

  useLayoutEffect(() => {
    document.title = 'Landscape - Home'
    setPageCode('home')
  }, [])

  useEffect(() => setSearchBarFocus(false), [setSearchBarFocus])

  return (
    <>
      <InstitutionInfo />

      <div className="cb-padding-bottom-48" id="main-content">
        <InfoSection>
          <h4
            id="Welcome to Landscape"
            aria-label="Welcome to Landscape"
            className="cb-roboto-slab-bold cb-margin-bottom-8"
          >
            Welcome to Landscape!
          </h4>
          <p>
            On this page you’ll find general information about this site and how to access the
            interface. Any questions can be sent to{' '}
            <ClickableLink href="mailto:futureadmissions@collegeboard.org">
              futureadmissions@collegeboard.org
            </ClickableLink>
          </p>
        </InfoSection>
        <InfoSection>
          <h4 className="cb-roboto-slab-bold cb-margin-bottom-8">How this site is organized</h4>
          <p>
            At the top of this page, you can access the interface via the Search box. You can also
            search for applicants on the Chart page, accessed via the hyperlink towards the top of
            this page. Those with administrator access can view the Jobs page, which shows file
            upload activity and jobs. This is where you’ll be able to upload data files and download
            processed files. The Help page contains links to helpful resources and training
            materials.
          </p>
        </InfoSection>

        <InfoSection>
          <h4 className="cb-roboto-slab-bold cb-margin-bottom-8">Requesting Access to Landscape</h4>
          <p>
            Individuals must have a College Board account to access this site. An access code is
            required in order to establish access. Institutions looking to integrate Landscape with
            their CRM should contact the College Board directly at{' '}
            <ClickableLink href="mailto:futureadmissions@collegeboard.org">
              futureadmissions@collegeboard.org
            </ClickableLink>{' '}
            to enable access. Any other questions can also be sent to{' '}
            <ClickableLink href="mailto:futureadmissions@collegeboard.org">
              futureadmissions@collegeboard.org
            </ClickableLink>
          </p>
        </InfoSection>
        {rid === '810' && <PreferencesSection />}
      </div>
    </>
  )
}

export { Home }
